import React, { useEffect, useState } from 'react';
import api from "../../utils/axiosInstance";
import CarrierHeader from '../../components/CarrierHeader';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const HOURS = [
    { slotNumber: 1, startTime: '08:00', endTime: '09:00' },
    { slotNumber: 2, startTime: '09:00', endTime: '10:00' },
    { slotNumber: 3, startTime: '10:00', endTime: '11:00' },
    { slotNumber: 4, startTime: '11:00', endTime: '12:00' },
    { slotNumber: 5, startTime: '12:00', endTime: '13:00' },
    { slotNumber: 6, startTime: '13:00', endTime: '14:00' },
    { slotNumber: 7, startTime: '14:00', endTime: '15:00' },
    { slotNumber: 8, startTime: '15:00', endTime: '16:00' },
    { slotNumber: 9, startTime: '16:00', endTime: '17:00' },
];

const parseTime = (timeStr, dateStr) => {
    if (!timeStr || !dateStr) return null;
    const [hours, minutes] = timeStr.split(':').map(Number);
    const d = new Date(dateStr);
    d.setHours(hours, minutes || 0, 0, 0);
    return d;
};

const CarrierLiveDemo = () => {
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [bookedSlots, setBookedSlots] = useState([]);
    const [selectedSlot, setSelectedSlot] = useState(null);
    const [loading, setLoading] = useState(false);

    const [successModalOpen, setSuccessModalOpen] = useState(false);
    const [bookingDetails, setBookingDetails] = useState(null);

    const carrier = JSON.parse(localStorage.getItem('carrierUser') || 'null');

    useEffect(() => {
        const fetchBookedSlots = async () => {
            try {
                const res = await api.get(`/demo-slots/booked`);
                const today = new Date();
                const upcomingSlots = (res.data.bookedSlots || []).filter(
                    slot => parseTime(slot.endTime || slot.end, slot.date) > today
                );
                setBookedSlots(upcomingSlots);
            } catch (err) {
                console.error(err);
                setBookedSlots([]);
            }
        };
        fetchBookedSlots();
    }, [selectedDate]);

    const isPastTime = (start, date) => {
        const slotStart = parseTime(start, date);
        const now = new Date();

        const isToday =
            new Date(date).toDateString() === new Date().toDateString();

        return isToday && slotStart < now;
    };

    const isSlotBooked = (start, end) => {
        if (isPastTime(start, selectedDate)) return true;

        return bookedSlots.some(slot =>
            slot.startTime === start && slot.endTime === end
        );
    };


    const handleBookClick = (start, end) => setSelectedSlot({ start, end });

    const handleConfirm = async () => {
        if (!selectedSlot || !carrier?._id) return;
        setLoading(true);
        try {
            const backendDate = selectedDate.toISOString().split("T")[0];

            const response = await api.post('/demo-slots/book-carrier', {
                date: backendDate,
                startTime: selectedSlot.start,
                endTime: selectedSlot.end,
                carrierId: carrier._id,
            });

            setBookingDetails({
                ...response.data.booking,
                calendarEvent: response.data.calendarEvent,
                message: response.data.message
            });

            const res = await api.get(`/demo-slots/booked?date=${selectedDate}`);
            setBookedSlots(res.data.bookedSlots || []);

            setSelectedSlot(null);
            setSuccessModalOpen(true);

        } catch (err) {
            alert(err.response?.data?.message || 'Unable to book slot!');
        }
        setLoading(false);
    };

    // NEW: Format date for display
    const formatDate = (dateStr) => {
        const date = new Date(dateStr);
        return date.toLocaleDateString('en-US', {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    };

    return (
        <div className="bg-gray-100 min-h-screen lg:pl-64">
            <CarrierHeader />
            <div className="max-w-4xl mx-auto px-4 py-8">
                {bookedSlots.length > 0 && (
                    <div className="mt-10 bg-white shadow rounded-lg p-6">
                        <h3 className="text-lg font-bold mb-2 text-gray-900">
                            Your Upcoming Live Demo / Onboarding sessions
                        </h3>

                        {bookedSlots
                            .filter(slot =>
                                slot.carrierId === carrier._id &&
                                new Date(`${slot.date}T${slot.endTime}:00`) > new Date()
                            )
                            .map(slot => (
                                <div key={slot._id} className="p-4 border rounded mb-4 bg-gray-50">
                                    <p className="font-semibold text-gray-800">
                                        {slot.startTime} – {slot.endTime}
                                    </p>
                                    <p className="text-sm text-gray-600">
                                        Date: {slot.date ? new Date(slot.date).toLocaleDateString("en-US") : "N/A"}
                                    </p>
                                    {/* UPDATED: Show meet link if available */}
                                    {slot.meetLink ? (
                                        <a
                                            href={slot.meetLink}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="inline-block mt-3 bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded transition"
                                            style={{ fontFamily: 'Oswald, sans-serif' }}
                                        >
                                            Join Meeting 🎥
                                        </a>
                                    ) : (
                                        <p className="text-blue-600 text-lg font-bold mt-4" style={{ fontFamily: 'Oswald, sans-serif' }}>
                                            Meeting link will be shared soon!
                                        </p>
                                    )}
                                </div>
                            ))}
                    </div>
                )}

                <h2 className="text-2xl font-bold mb-4">Live Demo / Onboarding</h2>
                <DatePicker
                    selected={selectedDate ? new Date(selectedDate) : null}
                    onChange={(date) => setSelectedDate(date)}
                    minDate={new Date()}
                    dateFormat="MM/dd/yyyy"
                    placeholderText="MM/DD/YYYY"
                    className="mb-6 p-2 border rounded"
                />

                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                    {HOURS.map(hr => {
                        const booked = isSlotBooked(hr.startTime, hr.endTime);

                        return (
                            <div
                                key={hr.slotNumber}
                                className={`rounded-lg shadow p-6 bg-white flex flex-col items-center ${booked ? 'opacity-50' : ''}`}
                            >
                                <div className="text-lg font-medium mb-2">
                                    {hr.startTime} – {hr.endTime}
                                </div>
                                <button
                                    disabled={booked}
                                    className={`px-4 py-1 rounded-lg text-white font-semibold ${booked
                                        ? 'bg-gray-400 cursor-not-allowed'
                                        : 'bg-blue-600 hover:bg-black'}`}
                                    onClick={() => handleBookClick(hr.startTime, hr.endTime)}
                                >
                                    {booked ? 'Unavailable' : 'Book'}
                                </button>
                            </div>
                        );
                    })}
                </div>


                {/* Booking Confirmation Modal */}
                {selectedSlot && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                        <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md text-center relative">
                            <button
                                onClick={() => setSelectedSlot(null)}
                                className="absolute top-2 right-2 text-gray-600 hover:text-blue-600 text-2xl font-bold"
                            >
                                &times;
                            </button>
                            <h3 className="text-xl font-bold mb-4">Confirm your time slot</h3>
                            <p className="mb-6 text-gray-800">
                                Book <b>{selectedSlot.start} – {selectedSlot.end}</b> on{" "}
                                <b>{selectedDate ? selectedDate.toLocaleDateString("en-US") : "N/A"}</b>?
                            </p>
                            <button
                                onClick={handleConfirm}
                                disabled={loading}
                                className="bg-blue-600 hover:bg-black text-white font-semibold px-5 py-2 rounded"
                            >
                                {loading ? 'Booking...' : 'Confirm'}
                            </button>
                        </div>
                    </div>
                )}

                {/* NEW: Success Modal with Google Meet Link */}
                {successModalOpen && bookingDetails && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                        <div className="bg-white p-8 rounded-lg shadow-xl w-full max-w-lg relative">
                            <button
                                onClick={() => {
                                    setSuccessModalOpen(false);
                                    setBookingDetails(null);
                                }}
                                className="absolute top-2 right-2 text-gray-600 hover:text-blue-600 text-2xl font-bold"
                            >
                                &times;
                            </button>

                            {/* Success Header */}
                            <div className="flex items-center justify-center mb-6">
                                <div className="bg-green-100 rounded-full p-3">
                                    <svg className="w-12 h-12 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                                    </svg>
                                </div>
                            </div>

                            <h2 className="text-2xl font-bold text-center text-green-600 mb-2">
                                Booking Confirmed!
                            </h2>
                            <p className="text-center text-gray-600 mb-6">
                                Your demo slot has been successfully booked
                            </p>

                            {/* Booking Details */}
                            <div className="bg-gray-50 rounded-lg p-4 mb-4 space-y-3">
                                <div className="flex items-center">
                                    <svg className="w-5 h-5 text-gray-600 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                    </svg>
                                    <span className="text-gray-700"><strong>Date:</strong> {formatDate(bookingDetails.date)}</span>
                                </div>

                                <div className="flex items-center">
                                    <svg className="w-5 h-5 text-gray-600 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                    <span className="text-gray-700"><strong>Time:</strong> {bookingDetails.startTime} - {bookingDetails.endTime}</span>
                                </div>
                            </div>

                            {/* Google Meet Link */}
                            {bookingDetails.calendarEvent?.meetLink && (
                                <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
                                    <div className="flex items-center mb-3">
                                        <svg className="w-5 h-5 text-blue-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                                        </svg>
                                        <span className="font-semibold text-blue-800">Google Meet Link</span>
                                    </div>
                                    <a
                                        href={bookingDetails.calendarEvent.meetLink}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition font-semibold"
                                    >
                                        Join Meeting
                                        <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                                        </svg>
                                    </a>
                                </div>
                            )}

                            {/* Information Box */}
                            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-4">
                                <div className="flex items-start">
                                    <svg className="w-5 h-5 text-yellow-600 mr-2 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                    <div className="text-sm text-yellow-800">
                                        <p className="font-semibold mb-1">What's Next?</p>
                                        <ul className="list-disc list-inside space-y-1">
                                            <li>Check your email for the calendar invite</li>
                                            <li>Add the event to your calendar</li>
                                            <li>You'll receive reminders before the meeting</li>
                                            <li>Use the Google Meet link to join at the scheduled time</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            {/* Close Button */}
                            <button
                                onClick={() => {
                                    setSuccessModalOpen(false);
                                    setBookingDetails(null);
                                }}
                                className="w-full px-4 py-3 bg-blue-600 text-white rounded-lg hover:bg-black transition font-semibold"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default CarrierLiveDemo;